import { useEffect, useState } from "react";
import axios from "axios";
import { server } from "../server";
import { buildAcceptedOfferPriceMap } from "../utils/offerPricing";

let cachedMap = null;
let cacheUserId = null;
let fetchPromise = null;

export function invalidateBuyerAcceptedOfferPricesCache() {
  cachedMap = null;
  cacheUserId = null;
  fetchPromise = null;
}

export function useBuyerAcceptedOfferPrices(userId, isAuthenticated) {
  const [offerPricesByProductId, setOfferPricesByProductId] = useState({});

  useEffect(() => {
    if (!isAuthenticated || !userId) {
      setOfferPricesByProductId({});
      if (!userId) {
        invalidateBuyerAcceptedOfferPricesCache();
      }
      return;
    }

    const userKey = String(userId);

    if (cacheUserId === userKey && cachedMap) {
      setOfferPricesByProductId(cachedMap);
      return;
    }

    if (!fetchPromise || cacheUserId !== userKey) {
      cacheUserId = userKey;
      fetchPromise = axios
        .get(`${server}/offer/my/all`, { withCredentials: true })
        .then(({ data }) => buildAcceptedOfferPriceMap(data?.offers || []))
        .catch(() => ({}))
        .then((map) => {
          cachedMap = map;
          return map;
        });
    }

    let cancelled = false;
    fetchPromise.then((map) => {
      if (!cancelled) {
        setOfferPricesByProductId(map);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [userId, isAuthenticated]);

  return offerPricesByProductId;
}
